/**
 * External dependencies
 */
import { defaults } from 'lodash';

/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { editReport } from 'state/reports/actions';
import { DEFAULT_NEW_REPORT_VALUES } from 'state/reports/constants';

export default (report) => (dispatch) => {
	let attributes = defaults({},report, DEFAULT_NEW_REPORT_VALUES);
	dispatch({ type: actions.REPORT_BUILDER_START, payload: { reportId: null } });
	dispatch(editReport(null, attributes));
};
